import { Button } from '@hai/ui-react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAdaptiveFetch } from 'src/js/hook/use-adaptive-fetch';
import { useStores } from 'src/js/hook/use-stores';
import { StatisticTable } from 'src/js/pages/statistic/statistic-table';

import { St2110ViewModel } from './st2110-models';
import { mapSt2110ToStatistics } from './st2110-statistics-content';
import { fetchSt2110Statistics, resetSt2110Statistics } from './st2110-store';

interface Props {
  model: St2110ViewModel;
}

export const St2110Statistics: React.FunctionComponent<Props> = ({ model }) => {
  const { t } = useTranslation();
  const { sessionStore } = useStores();

  const [data, setData] = useState(model);
  useAdaptiveFetch(() => fetchSt2110Statistics(model, t, setData), 5000);

  const handleResetStatistics = () => {
    resetSt2110Statistics(model, t, setData);
  };

  return (
    <>
      <div className="mk-stats-container">
        <StatisticTable sections={mapSt2110ToStatistics(data, t)} />
      </div>
      {!sessionStore.isUser() && (
        <div className="d-flex hai-mt-4">
          <Button className="ml-auto" variant="secondary" onClick={handleResetStatistics}>
            {t('general.reset')}
          </Button>
        </div>
      )}
    </>
  );
};
